import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import {Footer, Button} from './common/common';

import {isEmpty} from "../lib/tools";
import {reduxWrapper} from "../globalState";
import {SimpleHeader} from "./structure";
//Icons
import Arrow from "../resources/icons/longArrow_White.svg";
import starEmptyIcon from "../resources/icons/star-empty.png";
import starFullIcon from "../resources/icons/star-full.png";
import fragtGreenIcon from "../resources/icons/fragt-green.svg";
import kalendarGreenIcon from "../resources/icons/kalender-green.svg";
import kurvGreenIcon from "../resources/icons/kurv-green.svg";
//Images
import videoPoster from "../resources/images/videoPoster.jpg";
//Video
import frontVideo from "../resources/images/frontVideo.mp4";
import {BrowserView, MobileView} from 'react-device-detect';
import ReviewSlider from './reviewSlider/reviewSlider';

const reviews = [
	{
		rating: 5,
		name: "Tina Lundberg",
		comment: "Hurtig levering og alt var som det skulle være"
	},
	{
		rating: 4,
		name: "Susan Mortensen",
		comment: "Rigtig god og hurtig kundeservice"
	},
	{
		rating: 5,
		name: "Jesper Nygaard",
		comment: "Der var intet at sætte en finger på"
	},
	{
		rating: 5,
		name: "Anne Holm Jespersen",
		comment: "Maden var god og kom til tiden"
	}
]

const FrontPageRender = ({userInfo, awaitUserInfo}) => {
	const [showContestBtn, setShowContestBtn] = useState(false);
	
	useEffect(() => {
		awaitUserInfo(() => {
			if(!isEmpty(userInfo)) {
				if(!userInfo.inCompetition){
					setShowContestBtn(true);
				}else{
					setShowContestBtn(false);
				}
			}else{
				setShowContestBtn(true);
			}
		})
	}, [userInfo]);

	return(
		<div className="frontPageWrapper">
			<div className="videoWrapper">
				<div className="overlay"/>
				<video autoPlay muted loop poster={videoPoster} id="myVideo">
					<source src={frontVideo} type="video/mp4"/>
				</video>
			</div>
			
			<SimpleHeader/>

			<div className="frontPageMain">
				<div className="frontPageLeft">
					<div className="frontPageTitle">
						<h1 className="headline">MERE FEST MINDRE STRESS</h1>
						<p>
							Bliv inspireret af vores 100.000 festlige produkter, find bla. mad, drikkevarer, dekoration og meget mere. Der natuligvis leveres lige til døren.<br/><br/>
							Reserver din fest i dag og betal først 8 dage før festen skal afholdes.
						</p>
					</div>
					<div className="frontPageBtns">
						<Link className="fpBtn toDiy ga-toBygSelv" to={"/minfest"}>
							<span>Skræddersyet</span>
							<span className="title-m">Byg selv</span>
							<img src={Arrow} alt="Byg selv"/>
						</Link>
						<Link className="fpBtn toBundles ga-toBundles" to={"/pakker"}>
							<span>Færdige koncepter</span>
							<span className="title-m">Grydeklare fester</span>
							<img src={Arrow} alt="Til pakker"/>
						</Link>
					</div>
					{/* <div className="frontPageBtns">
						<Link to={"/konkurrence"} className="fpBtn toComp">
							<span>Konkurrence</span>
							<span className="title-m">Oversigt</span>
							<img src={Arrow} alt="arrow"/>
						</Link>
					{ showContestBtn && 
						<Link to={"/konkurrence/info"} className="fpBtn toComp">
							<span>Konkurrence</span>
							<span className="title-m">Deltag</span>
							<img src={Arrow} alt="arrow"/>
						</Link>
					}
					</div> */}
				</div>
			</div>

			<div className="priceMatch">
					<h1 className="headline">MERE FEST MINDRE STRESS</h1>
					<div>
						<div>
							<h2>PRISMATCH</h2>
							<span>MED DANSKE WEBSHOPS</span>
						</div>
						<div className="centerElement">
							<h2>100.000</h2>
							<span>PRODUCTER</span>
						</div>
						<div>
							<h2>FRI</h2>
							<span>FRAGT</span>
						</div>
					</div>
					<Button className="light" to="/handelsbetingelser#Prismatch">Læs mere</Button>
			</div>

			<div className="flexShippingWrapper">
				<h2 className="title-m">Flexible levering</h2>
				<p>
					For at gøre det hele nemmere, bestræber vi os på at vore kunder får sine pakker rettidigt. 
					Det vil sige at du kan handler ind i god tid, og få dine vare leveret lige når du skal bruge dem.
					Det kan være svært at dække bord når ens borde og stole først bliver leveret når festen er begyndt. 
					For at undgå dette, er det muligt at vælge præcist hvor og hvornår dine varer skal leveres. 
				</p>
				<div className="infoStepsWrapper">
					<div>
						<img src={kurvGreenIcon} alt="Sammensæt"/>
						<span>1. Sammensæt din fest</span>
						<span>Find det du skal bruge for at realisere din drømme fest.</span>
					</div>
					<div>
						<img src={kalendarGreenIcon} alt="Leverings tid"/>
						<span>2. Vælg leverings tid</span>
						<span>Vælg hvornår dine vare skal leveres, fx drikkevare skal leveres 4 dage før og maden på selve dagen.</span>
					</div>
					<div>
						<img src={fragtGreenIcon} alt="Modtag"/>
						<span>3. Modtag dine pakker</span>
						<span>Slå benene op og vent på at dine pakker kommer som aftalt.</span>
					</div>
				</div>
			</div>

			<BrowserView renderWithFragment> 
				<Ratings/>
			</BrowserView>
			
			<MobileView renderWithFragment>
				<ReviewSlider elements={reviews} intervalTime={5000} cssTimeout={500}/>
			</MobileView>

			<Footer/>
		</div>
	)
};
const FrontPage = reduxWrapper("getApiCall", "getLogOut", "loadUserInfo")(FrontPageRender);

const Ratings = () => {
	return(
		<div className="reviewWrapper">
			{reviews.map((x,i) => 
				<div key={i} className="review">
					<h1>{x.name}</h1>
					<p>"{x.comment}"</p>
					<div className="rating">
						{[...Array(x.rating)].map((y,d) => 
							<img key={d} src={starFullIcon} alt="Stjerne"/>
							)}
						{[...Array(5 - x.rating)].map((y,d) => 
							<img key={d} src={starEmptyIcon} alt="Stjerne"/>
							)}
					</div>
				</div>
			)}
	</div>
	)
}

export default FrontPage;


// WEBPACK FOOTER //
// ./src/components/frontPage.js